import React from 'react'
import { Link } from 'gatsby'
import { Box, Flex, Heading, Button } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

import { getDashboardCreateUserURL } from '../../utils/cta-utils'

const AddSection = ({
  purple,
  white,
  center,
  contentwall,
  cdp,
  liveblog,
  livechat,
  liveChatAllFeatures,
  cdpAllFeatures
}) => {
  const { t } = useTranslation('comoon')

  return (
    <Flex
      as="section"
      sx={{
        '&': purple && {
          backgroundImage: 'url(/bgAddPurple.png)',
          backgroundPosition: 'top center',
          backgroundRepeat: 'repeat',
          backgroundSize: 'cover'
        }
      }}
    >
      <Box
        maxWidth="container"
        width={1}
        mx="auto"
        pt={[20, 26]}
        px={[5, 5, 0]}
        pb={[12, 20, 30]}
        sx={{
          '@media (max-width: 32rem)': {
            '& a': {
              width: '100%'
            }
          }
        }}
      >
        <Heading
          maxWidth={center ? '854px' : '600px'}
          mx={center && 'auto'}
          mb={12}
          variant="level2"
          color={purple && 'white'}
          textAlign={center ? 'center' : ['center', 'left']}
        >
          {contentwall && t('add.title.contentwall')}
          {cdp && t('add.title.cdp')}
          {cdpAllFeatures && t('add.title.cdp_allfeatures')}
          {liveblog && t('add.title.liveblog')}
          {livechat && t('add.title.cdp')}
          {liveChatAllFeatures && t('add.title.livechat_allfeatures')}
        </Heading>

        <Flex flexDirection={['column', 'row']} justifyContent={center && 'center'}>
          <Link to={getDashboardCreateUserURL()}>
            <Button
              width={[1, '220px']}
              mr={[0, 5]}
              mb={[5, 0]}
              sx={{
                '&:hover': {
                  bg: 'blueGray'
                }
              }}
            >
              {t('add.buttons.start.text')}
            </Button>
          </Link>

          <Link to={t('add.buttons.contact.link')}>
            <Button width={[1, '220px']} height="55px" variant="tertiary" bg={white && 'blueGray'}>
              {t('add.buttons.contact.text')}
            </Button>
          </Link>
        </Flex>
      </Box>
    </Flex>
  )
}

AddSection.propTypes = {
  purple: PropTypes.bool,
  white: PropTypes.bool,
  center: PropTypes.bool,
  livechat: PropTypes.bool,
  liveChatAllFeatures: PropTypes.bool,
  liveblog: PropTypes.bool,
  cdpAllFeatures: PropTypes.bool,
  cdp: PropTypes.bool,
  contentwall: PropTypes.bool
}

export default AddSection
